var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStudentHat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.040 91.436c-12.5 0-28.372-2.624-35.444-9.992-0.356-0.368-0.556-0.864-0.556-1.38v-31c0-1.104 0.896-2 2-2s2 0.896 2 2v30.16c5.436 5.008 17.836 8.216 32 8.216s26.564-3.204 32-8.216v-30.16c0-1.104 0.9-2 2-2s2 0.896 2 2v31c0 0.516-0.2 1.012-0.556 1.384-7.072 7.364-22.944 9.988-35.444 9.988z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.040 79.064c-1.1 0-2-0.9-2-2v-28.228l-47.788-5.784c-1.092-0.132-1.88-1.132-1.748-2.228s1.128-1.872 2.228-1.752l49.548 6c1 0.124 1.76 0.976 1.76 1.988v30c0 1.104-0.9 2.004-2 2.004z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.496 32.564l55 7.5-55 12.5-50-12.5 50-7.5zM57.496 28.564c-0.196 0-0.4 0.016-0.592 0.044l-50 7.5c-1.884 0.284-3.312 1.86-3.4 3.764-0.092 1.904 1.172 3.608 3.024 4.072l50 12.5c0.32 0.084 0.644 0.12 0.972 0.12 0.296 0 0.592-0.032 0.888-0.1l55-12.5c1.884-0.428 3.192-2.148 3.108-4.076-0.084-1.932-1.544-3.528-3.456-3.788l-55-7.504c-0.184-0.020-0.364-0.032-0.544-0.032v0z",
    fill: "#000000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStudentHat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Student-Hat.725e5558.svg";
export { ForwardRef as ReactComponent };